export const toggleContainer = () => {
    const domain_check = window.location.href;
    const domain_name = localStorage.getItem('domain_name');
    if (domain_check.includes('vector')) {
      window.location.href = 'https://vector.cloobot.ai/v1/#/dream-dashboard';
    } else {
      window.location.href = `https://${domain_name}/v1/#/dream-dashboard`;
    }
    return true;
  };